<template>
    <div v-show="isLoaded" class="mSustainable-container" v-observe-visibility="startAnimate">
      <img class="mParallax rellax" 
      :src="background" 
      data-rellax-xs-speed="2" data-rellax-mobile-speed="2.5" data-rellax-tablet-speed="4.5" data-rellax-desktop-speed="7.5"
      alt="Imagen de un bosque">
    <h3 class="mSection-title" :class="{animate: animate}">Compromiso Sustentable</h3>
    <img class="mImg" :src="emperador" alt="Emperador Indio">
    <h4>Por un México más verde</h4>
    <a href="/sustentable" target="_self" rel="noopener noreferrer">Conoce más</a>
  </div>
</template>

<script>
import emperador from "@/assets/EMPERADOR-03.png"
import background from '@/assets/BACK SUSTENTABLE-02.png'
import Rellax from 'rellax'
import { mapGetters } from "vuex";

export default {
  name: "Sustainable",
  data() {
    return {
      emperador,
      background,
      animate: false,
      rellax: {}
    };
  },
    computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.rellax.refresh()
        this.animate=true
      }
      
    }
  },
  mounted() {
    this.rellax = new Rellax('.rellax', {
    speed: 0,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Sustainable.scss";
</style>
